import { FormGroup, ValidationErrors, ValidatorFn } from '@angular/forms';

export function createNumberRangeValidator(): ValidatorFn {
  return (form: FormGroup): ValidationErrors | null => {
    const min: number | null = form.get('min')?.value;
    const max: number | null = form.get('max')?.value;

    if (min == null || max == null) {
      return null;
    }

    return max >= min ? null : { range: true };
  };
}
